// core version + navigation, pagination modules:
import tailwindConfig from "../../tailwind.config.js";
const colors = tailwindConfig.theme.colors;
const screens = tailwindConfig.theme.screens;

import { $qs, $qsa } from "./utils/QuerySelector";
import gsap from "gsap";
import { CSSPlugin } from "gsap/CSSPlugin";
gsap.registerPlugin(CSSPlugin);

function mainMenu() {
	const mainMenuToggle = $qs('[data-name="mainMenuToggle"]');
	const mainMenuCurtain = $qs('[data-name="mainMenuCurtain"]');
	const mainMenu = $qs('[data-name="mainMenu"]');
	const mainMenuBox = $qs('[data-name="mainMenuBox"]');
	const hamburgerSlices = $qsa('[data-name="hamburgerSlice"]');
	const menuItemHasChildren = $qsa(".menu-item-has-children > a");
	const subMenus = $qsa(".sub-menu-wrap");
	const subMenuBack = $qsa('[data-name="sub-menu-back"]');
	const subMenuCrest = $qs('[data-name="sub-menu-crest"]');
	const toggleHamburger = $qsa("[data-toggle-hamburger]");

	const topLeveltoHide = $qsa(
		".menu-main-menu-container > ul > li > a, .menu-schools-container > ul > li > a, .menu-schools-container > ul > li > span, .menu-portals-container, [data-name='main-menus-divider']"
	);

	let mainMenuWidth = "570px";
	let subMenuWidth = "1050px";

	if (window.innerWidth < screens.xl.replace("px", "")) {
		//console.info("less than xl");
		mainMenuWidth = "490px";
		subMenuWidth = "930px";
	}
	if (window.innerWidth < screens.lg.replace("px", "")) {
		mainMenuWidth = "490px";
		subMenuWidth = "490px";
	}
	if (window.innerWidth < screens.sm.replace("px", "")) {
		mainMenuWidth = window.innerWidth + "px";
		subMenuWidth = window.innerWidth + "px";
	}

	let hamburgerTL = new gsap.timeline({
		defaults: { ease: "power2.inOut", duration: 0.5 },
		paused: true,
	});

	hamburgerTL
		.to(hamburgerSlices[0], { y: "8.5px" }, "start")
		.to(hamburgerSlices[2], { y: "-8.5px" }, "start")
		.to(hamburgerSlices[1], { opacity: 0, duration: 0.02 })
		.addLabel("rotate")
		.to(hamburgerSlices[0], { rotate: "45deg" }, "rotate")
		.to(hamburgerSlices[2], { rotate: "-45deg" }, "rotate");

	let hamburgerCloseTL = new gsap.timeline({
		defaults: { ease: "power2.inOut", duration: 0.5 },
		paused: true,
	});

	hamburgerCloseTL
		.to(hamburgerSlices[0], { y: "0" }, "start")
		.to(hamburgerSlices[2], { y: "0" }, "start")
		.to(hamburgerSlices[0], { rotate: "0" }, "start")
		.to(hamburgerSlices[2], { rotate: "0" }, "start")
		.to(hamburgerSlices[1], { opacity: 1, duration: 0.02 });

	document.addEventListener("click", function (e) {
		if (!mainMenu.contains(e.target) && !mainMenuToggle.contains(e.target)) {
			if (mainMenu.dataset.state == "open") closeMainMenu();
		}
	});

	mainMenuToggle.addEventListener("click", () => {
		if (mainMenu.dataset.state == "closed") {
			openMainMenu();
		} else {
			closeMainMenu();
		}
	});

	[...subMenuBack].forEach((item) => {
		item.addEventListener("click", () => {
			closeSubMenu();
		});
	});

	[...menuItemHasChildren].forEach((item) => {
		item.addEventListener("click", (e) => {
			e.preventDefault();

			let subState = mainMenu.dataset.subState;
			let subMenuTL = new gsap.timeline({
				defaults: { ease: "power2.inOut", duration: 0.5 },
			});
			const subLevel = $qs(".sub-menu-wrap", item.parentElement);

			gsap.to(menuItemHasChildren, { color: "white" });
			gsap.to(item, { color: colors.blue });
			if (subState != "open") {
				subMenuTL.to(mainMenuBox, { width: subMenuWidth });
				if (window.innerWidth < screens.lg.replace("px", "")) {
					gsap.to(topLeveltoHide, { autoAlpha: 0 });
				}
			} else {
				subMenuTL.to(subMenus, { autoAlpha: 0 });
			}

			subMenuTL.to(subLevel, { autoAlpha: 1 });
			subMenuTL.to(subMenuCrest, { opacity: 1 });

			mainMenu.dataset.subState = "open";
		});
	});

	[...toggleHamburger].forEach((item) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: "top 70px",
				// end: "bottom bottom",
				// end: window.innerHeight * 2,
				onEnter: () => updateMenuColour(item.dataset.toggleHamburger),
				onEnterBack: () => updateMenuColour(item.dataset.toggleHamburger),
				end: "bottom 70px",
				// markers: true,
			},
		});
	});

	function closeSubMenu() {
		let subMenuTL = new gsap.timeline({
			defaults: { ease: "power2.inOut", duration: 0.5 },
		});
		mainMenu.dataset.subState = "closed";
		gsap.to(subMenuCrest, { opacity: 0 });
		subMenuTL.to(".sub-menu-wrap", { autoAlpha: 0 });
		subMenuTL.to(mainMenuBox, { width: mainMenuWidth });
		gsap.to(menuItemHasChildren, { color: "white" });
		if (window.innerWidth < screens.lg.replace("px", "")) {
			gsap.to(topLeveltoHide, { autoAlpha: 1 });
		}
	}

	function openMainMenu() {
		// window.scrollTo({
		//     top: 0,
		//     behavior: 'smooth'
		// });
		gsap.to(mainMenuCurtain, { autoAlpha: 1 });
		gsap.to(mainMenu, { x: "0" });

		hamburgerTL.play(0);

		mainMenu.dataset.state = "open";
	}
	function closeMainMenu() {
		gsap.to(mainMenuCurtain, { autoAlpha: 0 });
		gsap.to(mainMenu, { x: "100%" });
		hamburgerCloseTL.play(0);
		mainMenu.dataset.state = "closed";
	}

	function openCurrentChild() {
		let currentAncestor = null;
		currentAncestor = $qs("#main-menu > li.current-menu-ancestor > a");

		if (!currentAncestor) {
			currentAncestor = $qs( "#menu-schools > li.current-menu-ancestor > a" );
		};
		
		if (!currentAncestor) return;
		currentAncestor.click();
	}

	openCurrentChild();

	function updateMenuColour(colour = null) {
		if (!colour) colour = mainMenuToggle.dataset.bgColor;
		if (colour == "blue") {
			mainMenuToggle.dataset.bgColor = "blue";
			gsap.to(mainMenuToggle, { backgroundColor: colors.blue, duration: 0.35 });
			gsap.to(hamburgerSlices, {
				backgroundColor: colors.white,
				duration: 0.35,
			});
		} else if (colour == "white") {
			mainMenuToggle.dataset.bgColor = "white";
			gsap.to(mainMenuToggle, {
				backgroundColor: colors.white,
				duration: 0.35,
			});
			gsap.to(hamburgerSlices, {
				backgroundColor: colors.blue,
				duration: 0.35,
			});
		}
	}
}

export default mainMenu;
